<tec-collapse
    [icon]="'icon-capture-popup'"
    [title]="'PROCESSES.DETAIL.DOCUMENTS' | translate"
    [expanded]="expandedCollapseSection === 'documents'"
    (clickEvent)="toggleCollapse('documents', $event)"
>
    @if (docsData?.state !== OPERATION_STATUS.INIT && docsData?.state !== OPERATION_STATUS.NOT_STARTED && docsData?.document && docsData.document.length > 0) {
        @for (doc of docsData.document; track $index) {
            <app-operation-document-list-item [doc]="doc" (open)="openDocument($event)" />
        }
    } @else {
        <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.DETAILS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
    }
</tec-collapse>

<tec-collapse
    [icon]="'icon-pending-check'"
    [title]="'OPERATIONS.DETAIL.TABS.DETAILS.OPERATION' | translate"
    [expanded]="expandedCollapseSection === 'operation'"
    (clickEvent)="toggleCollapse('operation', $event)"
>
    @if (docsData && detail) {
        <app-operation-detail-operation-meta
            [operationUuid]="docsData.uuid ?? detail.uuid"
            [processUuid]="detail.process_uuid"
            [startAt]="docsData.start_at"
            [endAt]="docsData.end_at"
            [totalTime]="docsData.total_time"
        />
    }
</tec-collapse>
